import VisibilityOff from '@mui/icons-material/VisibilityOffRounded';
import VisibilityOn from '@mui/icons-material/VisibilityRounded';
import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import IconButton from '@zenbusiness/zui/IconButton';

function VisibilityToggle({ isVisible, onToggle }) {
  const { formatMessage } = useIntl();

  const MESSAGE_IDS = {
    iconLabel: 'shopping.page.checkout.account.form.field.password.icon.label'
  };

  const Icon = isVisible ? VisibilityOff : VisibilityOn;

  return (
    <IconButton
      clickstreamProps={{
        elementName: 'password_visibility_toggle'
      }}
      icon={<Icon color="text.tertiary" sx={{ maxWidth: 24 }} />}
      label={formatMessage({ id: MESSAGE_IDS.iconLabel })}
      onClick={onToggle}
    />
  );
}

VisibilityToggle.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default VisibilityToggle;
